import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorType, DataResponse, ErrorsResponse } from '../models';


@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  // Password Recovery End point
  private environmentEndPoint = '/am/environment-password-recovery';

  constructor(private httpClient: HttpClient) { }

  // get environment
  public getEnvironment(): Observable<any> {
    console.log(this.environmentEndPoint);
    return this.httpClient.request('get', this.environmentEndPoint, { body: {} } )
      .pipe(map(this.getData), catchError(this.handleError));
  }

  // handle data
  private getData(response: DataResponse) {
    return response;
  }

  // handle error
  private handleError(httpError: ErrorsResponse) {
    return throwError(ErrorType.UnexpectedErrorMessage);
  }
}
